import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import SubmitButton from './SubmitButton';

function Text({ t, questionId, value, onSubmit }) {
  const [selectedAnswer, setSelectedAnswer] = useState(
    value ? value.opinion : '',
  );
  useEffect(() => setSelectedAnswer(value ? value.opinion : ''), [questionId]);

  const handleSubmit = () => onSubmit({ opinion: selectedAnswer });

  return (
    <div className="m-portlet__body quiz-answers-container">
      <h4>{t('survey_opinion_hint')}</h4>
      <div className="quiz-answer-list">
        <div className="quiz-input-container">
          <input
            style={{ fontSize: '1.3rem' }}
            className="form-control m-input"
            value={selectedAnswer || ''}
            onChange={({ currentTarget }) =>
              setSelectedAnswer(currentTarget.value)
            }
          />
        </div>
      </div>
      <SubmitButton
        onSubmit={handleSubmit}
        text={t('survey_setAnswer')}
        disabled={!selectedAnswer}
      />
    </div>
  );
}

Text.propTypes = {
  t: PropTypes.func.isRequired,
  questionId: PropTypes.string.isRequired,
  value: PropTypes.shape({ opinion: PropTypes.string.isRequired }),
  onSubmit: PropTypes.func.isRequired,
};

Text.defaultProps = {
  value: null,
};

export default translate(Text);
